export const useBrowserObject = (browserObjectName) => {
  if (process.browser) {
    // TODO: check better way to access browser objects
    return eval(browserObjectName)
  } else {
    return new Object()
  }
}
